// @ts-nocheck
/**
 * 6529.io API
 * This is the API interface description. Brief terminology overview and an authentication example can be found at <a href=\"https://6529.io/about/api\">https://6529.io/about/api</a>.
 *
 * OpenAPI spec version: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { HttpFile } from '../http/http';

export class SubscriptionResponse {
    'consolidation_key': string;
    'contract': string;
    'token_id': number;
    'subscribed': boolean;
    'subscribed_count': number;

    static readonly discriminator: string | undefined = undefined;

    static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
        {
            "name": "consolidation_key",
            "baseName": "consolidation_key",
            "type": "string",
            "format": ""
        },
        {
            "name": "contract",
            "baseName": "contract",
            "type": "string",
            "format": ""
        },
        {
            "name": "token_id",
            "baseName": "token_id",
            "type": "number",
            "format": "int64"
        },
        {
            "name": "subscribed",
            "baseName": "subscribed",
            "type": "boolean",
            "format": ""
        },
        {
            "name": "subscribed_count",
            "baseName": "subscribed_count",
            "type": "number",
            "format": "int64"
        }    ];

    static getAttributeTypeMap() {
        return SubscriptionResponse.attributeTypeMap;
    }

    public constructor() {
    }
}

